import { AccuracyTemplateInspectionGroup } from "@app/templates/accuracy/models";

export function filterPractitionerAtLocationConfidenceInspectionGroup(inspectionGroups: AccuracyTemplateInspectionGroup[], hidePractitionerAtLocationConfidence: boolean) : AccuracyTemplateInspectionGroup[] {
    if(hidePractitionerAtLocationConfidence){
      const filteredInspectionGroups = inspectionGroups.map((group) => {
        if(group.name === 'Integrity'){
          const filteredInspection = group.inspections.filter((inspection) => inspection.name !== 'Practitioner At Location Confidence');
          return {...group, inspections: filteredInspection}
        }
        return group;
      });
      return filteredInspectionGroups;
    }
    return inspectionGroups;
  }